export default "__VITE_ASSET__fga___UE0TaKOtsCwWAPAA__"